import React, { useEffect, useState } from "react";
import Loading from "../../../components/Loading";

export default function UnauthorizedPage() {
  const [permissionsReady, setPermissionsReady] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem("checkPermission")) {
        setPermissionsReady(true);
        clearInterval(interval);
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  if (!permissionsReady) {
    return <Loading />;
  }

  const handleGoBack = () => {
    window.history.back()
  }

  const handleGoHome = () => {
    window.location.href = "/"
  }

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light bg-gradient" style={{ background: "linear-gradient(135deg, #ffe5e5, #fff2e0)" }}>
      <div className="card shadow-lg border-0 p-4" style={{ maxWidth: "600px", width: "100%", backdropFilter: "blur(6px)", backgroundColor: "rgba(255, 255, 255, 0.9)" }}>
        <div className="text-center">
          {/* Shield Icon */}
          <div className="position-relative d-inline-block mb-4">
            <div className="bg-danger bg-gradient rounded-circle d-flex justify-content-center align-items-center" style={{ width: "96px", height: "96px" }}>
              <i className="bi bi-shield-lock-fill text-white fs-1"></i>
            </div>
            <div className="position-absolute top-0 end-0 translate-middle p-2 bg-warning rounded-circle shadow">
              <i className="bi bi-exclamation-triangle-fill text-danger"></i>
            </div>
          </div>

          {/* Headings */}
          <h1 className="display-4 fw-bold text-danger">403</h1>
          <h2 className="h4 fw-semibold text-dark">Access Denied</h2>
          <p className="text-muted mb-4">
            Sorry, you don't have permission to access this page. Please contact your administrator if you believe this is an error.
          </p>

          {/* Additional Info */}
          <div className="alert alert-warning bg-gradient px-4 py-3 mx-auto" style={{ maxWidth: "450px" }}>
            <strong>Need access?</strong> Contact your administrator to request permissions.
          </div>

          {/* Action Buttons */}
          <div className="d-grid gap-2 d-sm-flex justify-content-sm-center mt-4">
            <button onClick={handleGoBack} className="btn btn-outline-secondary d-flex align-items-center">
              <i className="bi bi-arrow-left me-2"></i> Go Back
            </button>

            <button onClick={handleGoHome} className="btn btn-danger text-white d-flex align-items-center">
              <i className="bi bi-house-door me-2"></i> Go Home
            </button>

          </div>

          {/* Footer */}
          <p className="mt-5 mb-0 text-muted small">Error Code: 403 | Unauthorized Access</p>
        </div>
      </div>
    </div>
  )
}
